var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-delivery-banner"},[_c('i',{staticClass:"mc-delivery-banner__icon icon-outline_alert-triangle"}),_c('div',{staticClass:"mc-delivery-banner__text"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }